import * as React from 'react';

import { useEventCallback } from './useEventCallback';

/**
 * Attach a function to be called before the user closes its browser. Optionally accepts an
 * onCancel handler. If the user cancels the action, the function will be called.
 */
export function useBeforeUnload(onBeforeUnload: (e?: Event) => string | null) {
    const onBeforeUnloadCb = useEventCallback(onBeforeUnload);
    React.useEffect(() => {
        const callback = (event: Event) => {
            const message = onBeforeUnloadCb(event);

            if (message == null) {
                return null;
            }

            // @ts-ignore
            event.returnValue = message;

            return message;
        };

        window.addEventListener('beforeunload', callback);

        return () => {
            window.removeEventListener('beforeunload', callback);
        };
    }, [onBeforeUnloadCb]);
}
